import { FC, useMemo } from 'react'
import { MediaChevronDownIcon } from '@ui/icons/media/media-chevron-down'

import { DialogTrigger } from '@ui/overlays/dialog/dialog-trigger';
import { Dialog } from '@ui/overlays/dialog/dialog';

import { DialogBody } from '@ui/overlays/dialog/dialog-body';
import { useNormalizedModels } from '@common/ui/normalized-model/use-normalized-models';

import { NormalizedModel } from '@player/types';
import { Link } from 'react-router';

import { Skeleton } from '@ui/skeleton/skeleton';
import { useDialogContext } from '@ui/overlays/dialog/dialog-context';

export const GenresHeader: FC = () => {

    return (
        <DialogTrigger mobileType="tray" placement="bottom-start" type="popover" triggerOnHover>
            <button
                className="border-r h-full pr-8 md:pr-20 text-sm hover:text-muted text-main flex items-center gap-10"
            >
                Genres
                <MediaChevronDownIcon className="w-16 h-16" />
            </button>

            <GenresHeaderDialog />
        </DialogTrigger>
    )
}

export const GenresHeaderDialog: FC = () => {
    const query = useNormalizedModels('normalized-models/genre', {
        perPage: 100,
        // @ts-ignore
        order: 'name:asc',
        minTracks: 150
    })

    // convert genres into 4 columns
    const genres = useMemo(() => {
        if (!query.data) return []

        const results = query.data.results
        const itemsPerColumn = Math.ceil(results.length / 4)
        const columns: NormalizedModel[][] = [[], [], [], []]

        results.forEach((model, index) => {
            const columnIndex = Math.floor(index / itemsPerColumn)
            columns[columnIndex]?.push(model)
        })

        return columns
    }, [query.data?.results])
    const loader = useMemo(() => Array.from({ length: 15 })?.map((_, index) => (
        <li
            className="py-10 border-b last-of-type:border-0 text-sm hover:text-muted text-main"
            key={`genresColumnLoader_${index}`}
        >
        <Skeleton variant="text" />
        </li>
)), [])

    const { close } = useDialogContext();

    return (
        <Dialog size="fullscreen">
            <DialogBody className="w-full">
                <div className="grid grid-cols-4 gap-20">
                    {query?.isLoading ? (
                        <>
                            <div>
                                <ul className="">
                                    {loader}
                                </ul>
                            </div>
                            <div>
                                <ul className="">
                                    {loader}
                                </ul>
                            </div>
                            <div>
                                <ul className="">
                                    {loader}
                                </ul>
                            </div>
                            <div>
                                <ul className="">
                                    {loader}
                                </ul>
                            </div>
                        </>
                    ) : genres?.map((models, index) => (
                        <div key={`genresColumn_${index}`}>
                            <ul className="">
                                {models?.map(model => (
                                    <li
                                        className="py-10 border-b last-of-type:border-0 text-sm hover:text-muted text-main"
                                        key={model.id}
                                    >
                                        <Link
                                           to={`/genre/${model?.slug || model?.name}`}
                                           onClick={() => close?.()}
                                        >
                                            {model?.display_name || model?.name}
                                        </Link>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </DialogBody>
        </Dialog>
    )
}
